import React from "react";
import Layout from "../containers/layout";
import Seo from "../components/seo";

import PageHeader from "../components/page-header-integration";
import IntegrationMain from "../components/integration-main-2";

const IntegrationTemplate = ({ pageContext }) => {
  const { 
    slug, 
    name,
    description,
    oem,
    appIntegrations,
    url
  } = pageContext;
  

  return (
    <Layout>
      <Seo
        title={name}
        description={description}
      />
      <PageHeader {...pageContext} titleWidth="xl" href={url}  descWidth="lg"/>
      <IntegrationMain name={name} slug={slug} appIntegrations={appIntegrations} />
      {oem && <div style={{position: 'fixed', 
                  bottom: '20px', 
                  right: '20px', 
                  backgroundColor: '#0098f0', 
                  color: 'white', 
                  fontWeight: 'bold', 
                  borderRadius:'0px', 
                  height:"70px", 
                  width: '70px', 
                  textAlign: 'center', 
                  fontSize: '10pt', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  borderRadius: '100px'}} title={`${name} is a Chain.io OEM partner. You may be able to use Chain.io as part of your existing license.`}>
        <div>
          OEM <br/> Partner
        </div>
      </div>}
    </Layout>
  );
};

export default IntegrationTemplate;
